<script setup>

import {Link, usePage} from "@inertiajs/vue3";
import {computed} from "vue";

const currentRoute = computed(() => usePage().url);

defineProps({
    route: String,
    title: String,
    icon: String,
})
</script>

<template>
    <div class="menu-item">
        <Link v-if="route" :href="route" :class="{ 'active': currentRoute === (route) }">
            <i :class="icon"></i>
            <span class="max-sm:hidden" v-if="currentRoute === (route)">{{ title }}</span>
        </Link>
        <div v-else>
            <i :class="icon"></i>
            <span v-if="currentRoute === (route)">{{ title }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
/* ODKAZY */
a, div {
    @apply flex flex-row gap-3 items-center text-neutral-700 dark:text-neutral-200 text-sm transition-all cursor-pointer duration-200 px-2 py-2;
}

i {
    @apply text-xl transition-all duration-200;
}

span {
    @apply  font-medium opacity-80;
}

/* AKTIVNÍ ODKAZ */
.active {
    @apply text-blue-600 dark:text-blue-400 font-semibold;
    i {
        @apply scale-110 transition-transform;
    }
}
</style>
